import { useState } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-studio-hub-33/artifacts/l67b1y1e_Color%20logo%20-%20no%20background.png";

const fontOptions = [
  {
    id: 1,
    name: "Bebas Neue",
    category: "Display / Condensed",
    description: "Ultra-bold, condensed, commanding presence. Used by Netflix, news outlets.",
    googleFont: "Bebas+Neue",
    style: { fontFamily: "'Bebas Neue', sans-serif", fontWeight: 400, letterSpacing: "0.02em" }
  },
  {
    id: 2,
    name: "Archivo Black",
    category: "Sans-serif / Heavy",
    description: "Super bold, wide stance, no-nonsense. Strong and industrial.",
    googleFont: "Archivo+Black",
    style: { fontFamily: "'Archivo Black', sans-serif", fontWeight: 400, letterSpacing: "-0.01em" }
  },
  {
    id: 3,
    name: "Oswald",
    category: "Sans-serif / Condensed",
    description: "Bold condensed, clean lines. Popular for headlines and titles.",
    googleFont: "Oswald:wght@700",
    style: { fontFamily: "'Oswald', sans-serif", fontWeight: 700, letterSpacing: "0em" }
  },
  {
    id: 4,
    name: "Montserrat Black",
    category: "Sans-serif / Geometric",
    description: "Modern geometric, very bold. Professional and contemporary.",
    googleFont: "Montserrat:wght@900",
    style: { fontFamily: "'Montserrat', sans-serif", fontWeight: 900, letterSpacing: "-0.02em" }
  },
  {
    id: 5,
    name: "Inter Black",
    category: "Sans-serif / Clean",
    description: "Clean, highly legible, modern. Used by GitHub, Linear, Figma.",
    googleFont: "Inter:wght@900",
    style: { fontFamily: "'Inter', sans-serif", fontWeight: 900, letterSpacing: "-0.02em" }
  },
  {
    id: 6,
    name: "Space Grotesk",
    category: "Sans-serif / Tech",
    description: "Techy, geometric, distinctive. Modern tech startup feel.",
    googleFont: "Space+Grotesk:wght@700",
    style: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, letterSpacing: "-0.02em" }
  }
];

// Load all Google Fonts
const fontLinks = fontOptions.map(f => f.googleFont).join("&family=");

export default function FontProposals() {
  const [selectedFont, setSelectedFont] = useState(null);

  return (
    <>
      {/* Load Google Fonts */}
      <link
        href={`https://fonts.googleapis.com/css2?family=${fontLinks}&display=swap`}
        rel="stylesheet"
      />
      
      <div className="min-h-screen bg-black text-white p-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-12 text-center">
            <img src={LOGO_URL} alt="Inopsia" className="h-12 mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-[#F87931] uppercase tracking-wider mb-2">
              Font Proposals
            </h1>
            <p className="text-gray-400">
              Click on any option to see it in a larger preview below
            </p>
          </div>

          {/* Font Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {fontOptions.map((font) => (
              <div
                key={font.id}
                onClick={() => setSelectedFont(font)}
                className={`bg-[#0A0A0A] border-2 p-6 cursor-pointer transition-colors ${
                  selectedFont?.id === font.id 
                    ? "border-[#F87931]" 
                    : "border-[#333] hover:border-[#555]"
                }`}
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="text-[#F87931] font-mono text-xs uppercase">
                    Option {font.id}
                  </span>
                  <span className="text-gray-500 font-mono text-xs">
                    {font.category}
                  </span>
                </div>
                
                <h2 
                  style={font.style}
                  className="text-4xl md:text-5xl text-white mb-2 uppercase"
                >
                  AI OPERATORS
                </h2>
                
                <p className="text-sm text-gray-500 mb-3">
                  {font.name}
                </p>
                
                <p className="text-xs text-gray-600">
                  {font.description}
                </p>
              </div>
            ))}
          </div>

          {/* Large Preview */}
          {selectedFont && (
            <div className="border-2 border-[#F87931] bg-[#0A0A0A] p-8 md:p-12">
              <div className="flex items-center justify-between mb-8">
                <span className="text-[#F87931] font-mono text-sm uppercase font-bold">
                  Preview: {selectedFont.name}
                </span>
                <button 
                  onClick={() => setSelectedFont(null)}
                  className="text-gray-500 hover:text-white text-sm"
                >
                  Close
                </button>
              </div>
              
              <div className="text-center">
                <p className="font-mono text-sm uppercase tracking-[0.3em] text-[#F87931] mb-6 font-bold">
                  Business & Finance AI Studio
                </p>
                
                <h1 
                  style={selectedFont.style}
                  className="text-5xl sm:text-6xl lg:text-8xl text-white uppercase mb-4"
                >
                  WHERE <span className="text-[#F87931]">AI OPERATORS</span>
                </h1>
                <h1 
                  style={selectedFont.style}
                  className="text-5xl sm:text-6xl lg:text-8xl text-white uppercase mb-8"
                >
                  BUILD <span className="text-[#F87931]">AI PRODUCTS</span>
                </h1>
                
                <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8">
                  Useful AI, not BS AI. We build agentic, generative, and next-gen AI solutions 
                  for business and finance — built by operators, for operators.
                </p>
                
                <div className="flex justify-center gap-6">
                  <button className="bg-[#F87931] text-black px-8 py-4 font-mono text-sm uppercase font-bold">
                    EXPLORE PRODUCTS
                  </button>
                  <button className="border-2 border-white text-white px-8 py-4 font-mono text-sm uppercase font-bold">
                    LET'S TALK
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Back Link */}
          <div className="text-center mt-12">
            <a href="/" className="text-gray-500 hover:text-[#F87931] font-mono text-sm">
              ← Back to Current Design
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
